'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');
var scrollToElement = require('scroll-to-element');
var pbizServer = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);

var utils = require('../../utils/main');
var modal = require('../../modal');
var appDom = require('../../app-dom');

var dom;
var addToCartText;

var setupDom = function() {

	dom = {};
	dom.bookingForm = appDom.document.find('.scheduler-booking-form');
	dom.serviceForm = appDom.document.find('.scheduler-detail__form');

};

var addEventHandlers = function() {

	appDom.document.on('click', '.js-book-now-btn', onBookNowClicked);
	appDom.document.on('click', '.scheduler-modal__close-btn', onModalCloseBtnClicked);
	appDom.document.on('click', '.scheduler-booking-form__add-to-cart-btn', onAddToCartBtnClicked);
	appDom.document.on('item_added_to_cart', resetBookingForm);
	dom.bookingForm.on('submit', onBookingFormSubmitted);

};

var onItemAddedToCart = function() {

	notify.hide();

	resetBookingForm();

};

var resetBookingForm = function() {

	dom.bookingForm[0].reset();

};

var onAddToCartBtnClicked = function(e) {

	var $addToCartBtn = $(this);

	dom.serviceForm = $addToCartBtn.parents('.block').find('.scheduler-detail__form');

	var $scheduleBtn = dom.serviceForm.find('.scheduler-detail__schedule-btn');

	var data = {};
	var serviceFormData = grabFormData(dom.serviceForm.serializeArray());
	var bookingFormData = grabFormData(dom.bookingForm.serializeArray());

	$.extend(data, serviceFormData);
	$.extend(data, bookingFormData);

	addToCartText = $addToCartBtn.text();

	$addToCartBtn.text(pbizServer.content['Generic.Loading']);

	// add some custom goodies
	data['sku'] = $scheduleBtn.attr('data-sku') ? $scheduleBtn.attr('data-sku') : '';
	data['sourceUrl'] = $scheduleBtn.attr('data-item-url');
	data['itemId'] = $scheduleBtn.attr('data-item-id');
	data['itemType'] = 'scheduler service';

	e.preventDefault();

	$.ajax({
		url: '/index.cfm?action=scheduler.processAddToCart',
		method: 'POST',
		dataType: 'JSON',
		data: data
	}).done(onAddToCartLinkClickedDone);

};


var onAddToCartLinkClickedDone = function(response) {

	dom.bookingForm.find('.scheduler-booking-form__add-to-cart-btn').text(addToCartText);

	if (response.status.code) {

		triggerCustomEvent('item_added_to_cart');

	} else {

		notify.show({
			target: $('[name="' + response.target + '"]'),
			msg: response.status.msg,
			closeOnClick: true
		});

	}

};

var onBookNowClicked = function(e) {

	dom.bookingForm.submit();

};

var onModalCloseBtnClicked = function() {

	window.location.reload();

};

var grabFormData = function(formArray) {

	var returnArray = {};

	for (var i = 0; i < formArray.length; i++){
		returnArray[formArray[i]['name']] = formArray[i]['value'];
	}

	return returnArray;

};

var onBookingFormSubmitted = function(e) {

	var data = grabFormData(dom.bookingForm.serializeArray());
	var $options = appDom.document.find('[name^="optionID_"]');
	var $times = appDom.document.find('.scheduler-times');

	$options.each(function(i, el) {
		data[$(el).attr('name')] = $(el).val();
	});

	e.preventDefault();

	$.ajax({
		url: utils.getUrl('scheduler.processBooking'),
		type: 'post',
		data: data
	}).done(onBookingFormSubmittedDone);

};

var onBookingFormSubmittedDone = function(response) {

	// default the "target" field to the first visible
	var $target = dom.bookingForm.find('input:visible').eq(0);

	// if target was explicitly provided, use the provided target
	if (response.target) {
		$target = $('[name="' + response.target + '"]');
	}

	if (response.status.code) {

		modal.open({
			url: utils.getUrl('scheduler.bookSuccess'),
			data: {
				appointmentDate: response.appointmentDate
			}
		});

	} else {

		$target.focus();

		notify.show({
			msg: response.status.msg,
			target: $target,
			container: dom.bookingForm,
			closeOnClick: true
		});

	}

};

var init = function() {

	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init
};
